import recommend from "@algolia/recommend";

export const recommendClient = recommend(
  process.env.GATSBY_ALGOLIA_APP_ID || "",
  process.env.GATSBY_ALGOLIA_SEARCH_KEY || ""
);
